<template>
  <div class="doctoralia-mappings">
    <div class="loading loading-lg" v-if="loading"></div>
    <template v-else>
      <div class="tile tile-centered tile-alert" v-if="hasAlert">
        <div class="tile-icon">
          <fa-icon :icon="['far', 'exclamation-triangle']" />
        </div>
        <div class="tile-content">
          <div class="tile-title">Atenção!</div>
          <div>
            Há registros com erros ou alertas.
            <span class="label label-error" v-if="errorAlertLabel">
              {{ errorAlertLabel }}
            </span>
            <span class="label label-warning" v-if="warningAlertLabel">
              {{ warningAlertLabel }}
            </span>
          </div>
        </div>
      </div>

      <table class="table">
        <colgroup>
          <col style="width:2.4rem">
          <col style="width:35%">
          <col style="width:1.4rem">
          <col style="">
          <col style="width:3.8rem;">
        </colgroup>
        <tbody>
        <mapping-item
          v-for="item in items"
          :key="item.key"
          :professional="item.professional"
          @alert="onAlert"
        ></mapping-item>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { first } from '@/helpers/array';
import * as professionalApi from '../../professional/api';
import MappingItem from './MappingItem.vue';

export default {
  components: {
    MappingItem,
  },
  data() {
    return {
      items: [],
      loading: false,
      alerts: {
        error: 0,
        warning: 0,
      },
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapState('doctoralia', {
      data: ({ data }) => data,
    }),
    hasAlert() {
      return this.alerts.error > 0 || this.alerts.warning > 0;
    },
    errorAlertLabel() {
      if (this.alerts.error === 1) {
        return '1 erro';
      }
      if (this.alerts.error > 1) {
        return `${this.alerts.error} erros`;
      }
      return null;
    },
    warningAlertLabel() {
      if (this.alerts.warning === 1) {
        return '1 alerta';
      }
      if (this.alerts.warning > 1) {
        return `${this.alerts.warning} alertas`;
      }
      return null;
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { items } = await professionalApi.allActive();
        this.items = items
          .map(item => ({
            key: item.id,
            selected: this.data.professionals.some(({ id }) => id === item.id),
            professional: {
              id: item.id,
              name: item.name,
              specialty: first(item.professional.specialties),
              council: first((
                item.professional.councils.filter(({ record }) => !!record)
              )),
            },
          }))
          .sort((a, b) => {
            if (a.selected && !b.selected) return -1;
            if (!a.selected && b.selected) return 1;
            return 0;
          });
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    onAlert({ type }) {
      if (type in this.alerts) {
        this.alerts[type] += 1;
      }
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";

.doctoralia-mappings {
  .tile-alert {
    background: $orange-color-100;
    border: $border-width solid $orange-color-400;
    border-radius: $border-radius;
    margin-bottom: $layout-spacing-lg;
    padding: $layout-spacing-lg;
    .tile-icon {
      color: $red-color-500;
      font-size: $layout-spacing-xl;
    }
    .tile-content {
      margin-left: $layout-spacing;
      .tile-title {
        font-weight: 500;
      }
      .label:not(:last-child) {
        margin-right: $layout-spacing-sm;
      }
    }
  }
  .table td {
    vertical-align: top;
  }
}
</style>
